import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import {MdAdd} from 'react-icons/md';

let CrearSolicitudButton = (props) => {
    return (
        <IconButton 
            aria-label="Add"
            onClick={() => props.onClick()}
        >
            <MdAdd />
        </IconButton>
    );
}

export default CrearSolicitudButton;

  

